import React from 'react'
import { TextField, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'

// const useStyles = makeStyles((theme) => ({
//   root: {
//     '& > *': {
//       margin: theme.spacing(1),
//       width: '25ch',
//     },
//   },
// }))

export const SearchUser = (props) => {
  //   const classes = useStyles()
  const { setKey, limit } = props

  const navigate = useNavigate()

  const handleSearch = (event) => {
    const value = event.target.value
    if (value) {
      setKey(value)
      navigate(`/admin?page=0&limit=${limit}`)
    } else {
      setKey('')
      navigate(`/admin?page=0&limit=${limit}`)
    }
  }
  return (
    <Box display='flex' flexDirection='column'>
      <TextField
        label='Search'
        variant='outlined'
        onChange={handleSearch}
        placeholder='Input email'
      />
    </Box>
  )
}
